import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const items = ['Qué tomas', 'Cuándo lo tomas', 'Qué te cambió el doctor', 'Cuál es tu próxima cita'];
export function ImagineSection() {
  return <section className="bg-cream py-24 px-6 md:px-12 lg:px-24" data-id="element-67">
      <div className="max-w-4xl mx-auto text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-[3rem] shadow-warm-lg border border-gold/10" data-id="element-69">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-8" data-id="element-70">
            Imagina esto…
          </h2>

          <p className="text-2xl text-navy/80 mb-10" data-id="element-71">
            En lugar de preocuparte, abres tu Checklist y sabes:
          </p>

          <div className="flex flex-col items-center space-y-4 mb-12" data-id="element-72">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex items-center space-x-4 bg-cream/50 px-8 py-4 rounded-full w-full max-w-md justify-start" data-id="element-73">
                <div className="bg-sage/20 p-2 rounded-full" data-id="element-74">
                  <CheckIcon className="w-6 h-6 text-sage" data-id="element-75" />
                </div>
                <span className="text-xl md:text-2xl text-navy font-medium" data-id="element-76">
                  {item}
                </span>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="text-3xl md:text-4xl font-bold text-gold" data-id="element-77">
            Eso es tranquilidad. ✨
          </motion.p>
        </motion.div>
      </div>
    </section>;
}